import { useImageQuery } from '@scoring/api';
import { Avatar, type AvatarProps } from '@scoring/ui';
import { useEffect, useMemo } from 'react';

export interface ApiImageAvatarProps extends AvatarProps {
    name: string;
    imageId: string | null | undefined;
}

export const ApiImageAvatar: React.FC<ApiImageAvatarProps> = ({ name, imageId, ...props }) => {
    const { data: blob } = useImageQuery(imageId);
    const src = useMemo(() => (blob ? URL.createObjectURL(blob) : undefined), [blob]);
    useEffect(() => {
        return () => {
            if (src) URL.revokeObjectURL(src);
        };
    }, [src]);
    return <Avatar name={name} src={src} {...props} />;
};
